import type { Industry } from './api'

export function isHealthcareIndustry(industry: Industry | undefined): boolean {
  return industry === 'hospital' || industry === 'clinic'
}

export function audienceLabel(industry: Industry | undefined): string {
  return isHealthcareIndustry(industry) ? 'Patient' : 'Customer'
}

export function audienceLabelPlural(industry: Industry | undefined): string {
  return `${audienceLabel(industry)}s`
}
